export default "__VITE_ASSET__3162c67e__"